import './GPUResults.css';
import GPUResultsRow from './GPUResultsRow';

function GPUResults(props) {
  return (
    <div className="GPUResults">
      <div className='GPUResultsHeader'>
        <div>
          <h2>{props.selectedGPU === 'Any' ? 'All GPUs' : props.selectedGPU}</h2>
          <p className='GPUResultsSummary'>
            {props.loading
              ? 'Loading bundled CSV results...'
              : `Showing ${props.gpuResults.length} result${props.gpuResults.length === 1 ? '' : 's'} for the current filters.`}
          </p>
        </div>
        <div className='CLevelSelector'>
          <label>
            K-Size
            <select value={props.kSize} onChange={(event)=>{props.setKSize(event.target.value)}}>
            {props.kSizeArray.map((value) =>(
                <option key={value} value={value}>K{value}</option>
            ))}
            </select>
          </label>
          <label>
            C-Level
            <select value={props.cLevel} onChange={(event)=>{props.setCLevel(event.target.value)}}>
              <option value="Any">Any</option>
            {props.cLevelArray.map((value) =>(
                <option key={value} value={value}>{value}</option>
            ))}
            </select>
          </label>
          <label>
            GH Version
            <select value={props.gigaVersion} onChange={(event)=>{props.setGigaVersion(event.target.value)}}>
              <option value="Any">Any</option>
              {props.gigaVersionArray.map((value) =>(
            <option key={value} value={value}>{value}</option>
            ))}
            </select>
          </label>
        </div>
      </div>
      <p className='GPUResultsStatus'>Filters: [GPU: {props.selectedGPU}] [K-Size: {props.kSize}] [C-Level: {props.cLevel}] [Version: {props.gigaVersion}]</p>
      {props.gpuResults.length > 0 ? 
            <>
                {props.gpuResults.map((resultElement, index) => 
                    <GPUResultsRow key={index} resultElement={resultElement} index={index} selectedGPU={props.selectedGPU}/>
                )}
            </>
            :
            <>
                <p className='GPUResultsEmpty'>
                  {props.loading ? 'Loading bundled CSV...' : 'No results matched those filters.'}
                </p>
            </>}
    </div>
  );
}

export default GPUResults;
